import { Routes, Route, Navigate } from "react-router-dom";


import OverlandLogistics from "./OverlandLogistics";

const overlandlogisticsRoutes = [
    
    {routeName: 'door-to-door' , component: <OverlandLogistics/>},
    {routeName: 'temperature-control' , component: <OverlandLogistics/>},
    {routeName: 'dry-cargo' , component: <OverlandLogistics/>},
    {routeName: 'hub-to-hub' , component: <OverlandLogistics/>},
    {routeName: 'tcs-fresh' , component: <OverlandLogistics/>},
    {routeName: 'customized-solutions' , component: <OverlandLogistics/>},
    {routeName: 'ecom-segment' , component: <OverlandLogistics/>},
];

const OverlandLogisticsRoutes = () => {
    return (
    <Routes>
       {overlandlogisticsRoutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default OverlandLogisticsRoutes;